import { QUESTION_TYPE } from '../../fetchSurvey/constants/questionTypes';
import type { SurveyQuestion } from '../../fetchSurvey/types/index';
import type { StatementRow } from '../../fetchSurvey/types/shared';
import type { MatrixRowAnswers } from '../../submitSurvey/types';

export function isMatrixQuestion(question: SurveyQuestion | undefined): boolean {
  if (!question) return false;
  if (
    question.type !== QUESTION_TYPE.CSAT_MATRIX &&
    question.type !== QUESTION_TYPE.CFM_MATRIX &&
    question.type !== QUESTION_TYPE.RATING_MATRIX &&
    question.type !== QUESTION_TYPE.SLIDER_MATRIX
  ) {
    return false;
  }
  return Array.isArray(question.statementRows) && question.statementRows.length > 0;
}

export function isMatrixRowAnswers(value: unknown): value is MatrixRowAnswers {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function matrixHasAnyAnswer(answerMap: MatrixRowAnswers): boolean {
  return Object.values(answerMap).some(rowValue => {
    if (rowValue === undefined || rowValue === null) return false;
    if (Array.isArray(rowValue)) return rowValue.length > 0;
    return true;
  });
}

/** True when the matrix answer is absent or no row has a value (N/A-only counts as empty). */
export function isMatrixAnswerMapEmpty(answer: unknown): boolean {
  if (!isMatrixRowAnswers(answer)) return true;
  return !matrixHasAnyAnswer(answer);
}

/** Show row labels only when CSAT/RATING/SLIDER matrix has more than one visible statement row. */
export function shouldShowMatrixStatementLabels(question: {
  type: SurveyQuestion['type'];
  statementRows?: StatementRow[];
}): boolean {
  if (
    question.type !== QUESTION_TYPE.CSAT_MATRIX &&
    question.type !== QUESTION_TYPE.RATING_MATRIX &&
    question.type !== QUESTION_TYPE.SLIDER_MATRIX
  ) {
    return true;
  }
  return (question.statementRows?.length ?? 0) > 1;
}
